<div class="menu-heading">RCN Help</div>
<ul class="admin__nav">
    <li><a routerLink="/help" target="_blank">Product Guide</a></li>
    <li><a routerLink="/admin/user">What's New</a></li>
    <li><a routerLink="/admin/master-activities">Contact Support Team</a></li> 
</ul>